import * as React from "react";
import { atomFamily, useRecoilState, useRecoilValue } from "recoil";

import { UserState } from "@/view_models/atoms";

const enteredState = atomFamily<boolean, string>({ key: "plannerIntroductionEntered", default: false });

/** 登録中に前の説明へ戻った場合は、同じ演出の待ち時間を繰り返さない。 */
export function usePlannerIntroductionEntrance(screen: "intro" | "certified") {
  const user = useRecoilValue(UserState);
  const [entered, setEntered] = useRecoilState(enteredState(`${user?.id ?? 0}:${screen}`));
  const animate = React.useRef(!entered).current;
  React.useEffect(() => { setEntered(true); }, [setEntered]);
  return animate;
}
